import ReactPixel from 'react-facebook-pixel';
import { FACEBOOK_PIXEL_ID } from '../../config';

const advancedMatching = {}; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: false, // enable logs
};

const init = (trackingID = FACEBOOK_PIXEL_ID) =>
  ReactPixel.init(trackingID, advancedMatching, options);

const pageView = () => ReactPixel.pageView(); // For tracking page view

const track = (event, data) => ReactPixel.track(event, data); // For tracking default events. More info about standard events: https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking#standard-events

const trackSingle = (trackingID = FACEBOOK_PIXEL_ID, event, data) =>
  ReactPixel.trackSingle(trackingID, event, data); // For tracking default events.

const trackCustom = (event, data) => ReactPixel.trackCustom(event, data); // For tracking custom events. More info about custom events: https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking#custom-events

const trackSingleCustom = (trackingID = FACEBOOK_PIXEL_ID, event, data) =>
  ReactPixel.trackSingleCustom(trackingID, event, data);

const FacebookPixels = {
  init,
  pageView,
  track,
  trackSingle,
  trackCustom,
  trackSingleCustom,
};

export default FacebookPixels;
